import { TransportMode } from '@hazmatsuite-next/ui';
import { EasyDgdStep } from './easydgd.step.enum';
import { ShippingPaper } from './shipping-paper.model';

export class EasyDgdDataModel {
  public Step?: EasyDgdStep;
  public TransportMode: TransportMode = TransportMode.Unknown;
  public ShippingPaper?: ShippingPaper;
}
